export default "__VITE_ASSET__DTjOdPmg__"